import "../assets/index-f9bfa317.css";
import "@nextcloud/vue-select/dist/vue-select.css";
import { VueSelect as s } from "@nextcloud/vue-select";
import { autoUpdate as p, computePosition as f, offset as d, flip as m, shift as y, limitShift as _ } from "@floating-ui/dom";
import { t as c } from "../chunks/l10n-1b905a9a.mjs";
import { C as h } from "../chunks/ChevronDown-a72d365d.mjs";
import { C as g } from "../chunks/Close-271f72e2.mjs";
import b from "./NcEllipsisedOption.mjs";
import S from "./NcListItemIcon.mjs";
import L from "./NcLoadingIcon.mjs";
import { l as C } from "../chunks/l10n-6cfc1200.mjs";
import { G as v } from "../chunks/GenRandomId-cb9ccebe.mjs";
import { n as N } from "../chunks/_plugin-vue2_normalizer-71e2aa87.mjs";
const B = {
  name: "NcSelect",
  components: {
    ChevronDown: h,
    NcEllipsisedOption: b,
    NcListItemIcon: S,
    NcLoadingIcon: L,
    VueSelect: s
  },
  mixins: [
    C
  ],
  props: {
    // Add VueSelect props to $props
    ...s.props,
    /**
     * `aria-label` for the clear input button
     */
    ariaLabelClearSelected: {
      type: String,
      default: c("Clear selected")
    },
    /**
     * `aria-label` for the search input
     */
    ariaLabelCombobox: {
      type: String,
      default: c("Search for options")
    },
    /**
     * Allows to customize the `aria-label` for the deselect-option button
     * The default is "Deselect " + optionLabel
     * @type {(optionLabel: string) => string}
     */
    ariaLabelDeselectOption: {
      type: Function,
      default: (l) => c("Deselect {option}", { option: l })
    },
    /**
     * Append the dropdown element to the end of the body
     * and size/position it dynamically.
     *
     * @see https://vue-select.org/api/props.html#appendtobody
     */
    appendToBody: {
      type: Boolean,
      default: !0
    },
    /**
     * When `appendToBody` is true, this function is responsible for
     * positioning the drop down list.
     *
     * If a function is returned from `calculatePosition`, it will
     * be called when the drop down list is removed from the DOM.
     * This allows for any garbage collection you may need to do.
     *
     * @see https://vue-select.org/api/props.html#calculateposition
     */
    calculatePosition: {
      type: Function,
      default: null
    },
    /**
     * Close the dropdown when selecting an option
     *
     * @see https://vue-select.org/api/props.html#closeonselect
     */
    closeOnSelect: {
      type: Boolean,
      default: !0
    },
    /**
     * Replace default vue-select components
     *
     * @see https://vue-select.org/api/props.html#components
     */
    components: {
      type: Object,
      default: () => ({
        Deselect: {
          render: (l) => l(g, {
            props: {
              size: 20,
              fillColor: "var(--vs-controls-color)"
            },
            style: {
              cursor: "pointer"
            }
          })
        }
      })
    },
    /**
     * Sets the maximum number of options to display in the dropdown list
     */
    limit: {
      type: Number,
      default: null
    },
    /**
     * Disable the component
     *
     * @see https://vue-select.org/api/props.html#disabled
     */
    disabled: {
      type: Boolean,
      default: !1
    },
    /**
     * Determines whether the dropdown should be open.
     * Receives the component instance as the only argument.
     *
     * @see https://vue-select.org/api/props.html#dropdownshouldopen
     */
    dropdownShouldOpen: {
      type: Function,
      default: ({ noDrop: l, open: e }) => l ? !1 : e
    },
    /**
     * Callback to determine if the provided option should
     * match the current search text. Used to determine
     * if the option should be displayed.
     *
     * Defaults to the internal vue-select function documented at the link
     * below
     *
     * Enabling `userSelect` will automatically set this to filter by the
     * `displayName` and `subname` properties of the user option object
     * unless this prop is set explicitly
     *
     * @see https://vue-select.org/api/props.html#filterby
     */
    filterBy: {
      type: Function,
      default: null
    },
    /**
     * Class for the `input`
     *
     * Necessary for use in NcActionInput
     */
    inputClass: {
      type: [String, Object],
      default: null
    },
    /**
     * Input element id
     *
     * @see https://vue-select.org/api/props.html#inputid
     */
    inputId: {
      type: String,
      default: null
    },
    /**
     * Display a visible border around dropdown options
     * which have keyboard focus
     */
    keyboardFocusBorder: {
      type: Boolean,
      default: !0
    },
    /**
     * Key of the displayed label for object options
     *
     * Defaults to the internal vue-select string documented at the link
     * below
     *
     * Enabling `userSelect` will automatically set this to `'displayName'`
     * unless this prop is set explicitly
     *
     * @see https://vue-select.org/api/props.html#label
     */
    label: {
      type: String,
      default: null
    },
    /**
     * Show the loading icon
     *
     * @see https://vue-select.org/api/props.html#loading
     */
    loading: {
      type: Boolean,
      default: !1
    },
    /**
     * Allow selection of multiple options
     *
     * @see https://vue-select.org/api/props.html#multiple
     */
    multiple: {
      type: Boolean,
      default: !1
    },
    /**
     * Disable automatic wrapping when selected options overflow the width
     */
    noWrap: {
      type: Boolean,
      default: !1
    },
    /**
     * Array of options
     *
     * @type {Array<string | number | Record<string | number, any>>}
     *
     * @see https://vue-select.org/api/props.html#options
     */
    options: {
      type: Array,
      default: () => []
    },
    /**
     * Placeholder text
     *
     * @see https://vue-select.org/api/props.html#placeholder
     */
    placeholder: {
      type: String,
      default: ""
    },
    /**
     * Customized component's response to keydown events while the search input has focus
     *
     * @see https://vue-select.org/guide/keydown.html#mapkeydown
     */
    mapKeydown: {
      type: Function,
      /**
       * Patched Vue-Select keydown events handlers map to stop Escape propagation in open select
       *
       * @param {Record<number, Function>} map - Mapped keyCode to handlers { <keyCode>:<callback> }
       * @param {import('@nextcloud/vue-select').VueSelect} vm - VueSelect instance
       * @return {Record<number, Function>} patched keydown event handlers
       */
      default(l, e) {
        return {
          ...l,
          /**
           * Patched Escape handler to stop propagation from open select
           *
           * @param {KeyboardEvent} event - default keydown event handler
           */
          27: (o) => {
            e.open && o.stopPropagation(), l[27](o);
          }
        };
      }
    },
    /**
     * A unique identifier used to generate IDs and DOM attributes. Must be unique for every instance of the component.
     *
     * @see https://vue-select.org/api/props.html#uid
     */
    uid: {
      type: String,
      default: () => "-" + v()
    },
    /**
     * When `appendToBody` is true, this sets the placement of the dropdown
     *
     * @type {'bottom' | 'top'}
     */
    placement: {
      type: String,
      default: "bottom"
    },
    /**
     * If false, the focused dropdown option will not be reset when filtered
     * options change
     */
    resetFocusOnOptionsChange: {
      type: Boolean,
      default: !0
    },
    /**
     * Enable the user selector with avatars
     *
     * Objects must contain the data expected by the
     * [NcListItemIcon](#/Components/NcListItemIcon) and
     * [NcAvatar](#/Components/NcAvatar) components
     */
    userSelect: {
      type: Boolean,
      default: !1
    },
    /**
     * Currently selected value
     *
     * The `v-model` directive may be used for two-way data binding
     *
     * @type {string | number | Record<string | number, any> | Array<any>}
     *
     * @see https://vue-select.org/api/props.html#value
     */
    value: {
      type: [String, Number, Object, Array],
      default: null
    },
    /**
     * Any available prop
     *
     * @see https://vue-select.org/api/props.html
     */
    // Not an actual prop but needed to show in vue-styleguidist docs
    // eslint-disable-next-line
    " ": {}
  },
  emits: [
    /**
     * All events from https://vue-select.org/api/events.html
     */
    // Not an actual event but needed to show in vue-styleguidist docs
    " "
  ],
  data() {
    return {
      search: ""
    };
  },
  computed: {
    localCalculatePosition() {
      return this.calculatePosition !== null ? this.calculatePosition : (l, e, { width: o }) => {
        l.style.width = o;
        const t = {
          name: "addClass",
          fn(n) {
            return l.classList.add("vs__dropdown-menu--floating"), {};
          }
        }, a = {
          name: "togglePlacementClass",
          fn({ placement: n }) {
            return e.$el.classList.toggle(
              "select--drop-up",
              n === "top"
            ), l.classList.toggle(
              "vs__dropdown-menu--floating-placement-top",
              n === "top"
            ), {};
          }
        }, r = () => {
          f(e.$refs.toggle, l, {
            placement: this.placement,
            middleware: [
              d(-1),
              t,
              a,
              // Match popperjs default collision prevention behavior by appending the following middleware in order
              m(),
              y({ limiter: _() })
            ]
          }).then(({ x: n, y: u }) => {
            Object.assign(l.style, {
              left: `${n}px`,
              top: `${u}px`
            });
          });
        };
        return p(
          e.$refs.toggle,
          l,
          r
        );
      };
    },
    localFilterBy() {
      const l = /[^<]*<([^>]+)/;
      return this.filterBy !== null ? this.filterBy : this.userSelect ? (e, o, t) => {
        var r, i, n;
        const a = t.match(l);
        return a && ((n = (i = (r = e.subname) == null ? void 0 : r.toLocaleLowerCase) == null ? void 0 : i.call(r)) == null ? void 0 : n.indexOf(a[1].toLocaleLowerCase())) > -1 || `${o} ${e.subname}`.toLocaleLowerCase().indexOf(t.toLocaleLowerCase()) > -1;
      } : s.props.filterBy.default;
    },
    localLabel() {
      return this.label !== null ? this.label : this.userSelect ? "displayName" : s.props.label.default;
    },
    propsToForward() {
      const {
        // Props handled by this component
        inputClass: l,
        noWrap: e,
        placement: o,
        userSelect: t,
        // Props to forward
        ...a
      } = this.$props;
      return {
        ...a,
        // Custom overrides of vue-select props
        calculatePosition: this.localCalculatePosition,
        filterBy: this.localFilterBy,
        label: this.localLabel
      };
    }
  }
};
var I = function() {
  var e = this, o = e._self._c;
  return o("VueSelect", e._g(e._b({ staticClass: "select", class: {
    "select--no-wrap": e.noWrap,
    "user-select": e.userSelect
  }, on: { search: (t) => e.search = t }, scopedSlots: e._u([{ key: "search", fn: function({ attributes: t, events: a }) {
    return [o("input", e._g(e._b({ class: ["vs__search", e.inputClass] }, "input", t, !1), a))];
  } }, { key: "open-indicator", fn: function({ attributes: t }) {
    return [o("ChevronDown", e._b({ attrs: { "fill-color": "var(--vs-controls-color)", size: 26 } }, "ChevronDown", t, !1))];
  } }, { key: "option", fn: function(t) {
    return [e.userSelect ? o("NcListItemIcon", e._b({ attrs: { "avatar-size": 24, name: t[e.localLabel], search: e.search } }, "NcListItemIcon", t, !1)) : o("NcEllipsisedOption", { attrs: { name: String(t[e.localLabel]), search: e.search } })];
  } }, { key: "selected-option", fn: function(t) {
    return [e.userSelect ? o("NcListItemIcon", e._b({ attrs: { "avatar-size": 24, name: t[e.localLabel], search: e.search } }, "NcListItemIcon", t, !1)) : o("NcEllipsisedOption", { attrs: { name: String(t[e.localLabel]), search: e.search } })];
  } }, { key: "spinner", fn: function(t) {
    return [t.loading ? o("NcLoadingIcon") : e._e()];
  } }, { key: "no-options", fn: function() {
    return [e._v(" " + e._s(e.t("No results")) + " ")];
  }, proxy: !0 }, e._l(e.$scopedSlots, function(t, a) {
    return { key: a, fn: function(r) {
      return [e._t(a, null, null, r)];
    } };
  })], null, !0) }, "VueSelect", e.propsToForward, !1), e.$listeners));
}, w = [], F = /* @__PURE__ */ N(
  B,
  I,
  w,
  !1,
  null,
  null,
  null,
  null
);
const G = F.exports;
export {
  G as default
};
